import React from 'react';
import { Link } from 'react-router-dom';
import PageNotFoundImg from '../assets/page-not-found.jpg';


const PageNotFound = () => {
	return (
		<div className="conatiner">
			<div className='text-center auto-margin text-primary'>
				<Link to="/">Go Back Home</Link>
				<br />
				<img src={PageNotFoundImg} alt="Looks like you are off the map. Let`s get you back on track"/>
			</div>
		</div>
	);
};

export default PageNotFound;
